export default function Footer() {
  return (
    <footer id="footer" className="bg-background-900 text-background-200 pt-16 pb-8">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
          <div>
            <h3 className="font-heading text-lg font-bold text-background-50 mb-3">7777影院</h3>
            <p className="text-sm text-background-400 leading-relaxed">
              你的免费高清在线观影平台。海量资源、极速播放、纯净体验，随时随地畅享影视世界。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-100 mb-3">快速导航</h4>
            <div className="flex flex-col gap-2">
              <a href="#hero" className="text-sm text-background-400 hover:text-primary-400 cursor-pointer transition-colors whitespace-nowrap">首页</a>
              <a href="#ranking" className="text-sm text-background-400 hover:text-primary-400 cursor-pointer transition-colors whitespace-nowrap">热播榜单</a>
              <a href="#cards" className="text-sm text-background-400 hover:text-primary-400 cursor-pointer transition-colors whitespace-nowrap">精选专题</a>
              <a href="#faq" className="text-sm text-background-400 hover:text-primary-400 cursor-pointer transition-colors whitespace-nowrap">常见问答</a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-100 mb-3">资源分类</h4>
            <div className="flex flex-col gap-2">
              <a href="#index" className="text-sm text-background-400 hover:text-primary-400 cursor-pointer transition-colors whitespace-nowrap">类型索引</a>
              <a href="#topics" className="text-sm text-background-400 hover:text-primary-400 cursor-pointer transition-colors whitespace-nowrap">热门话题</a>
              <a href="#carousel" className="text-sm text-background-400 hover:text-primary-400 cursor-pointer transition-colors whitespace-nowrap">焦点专题</a>
              <a href="#updates" className="text-sm text-background-400 hover:text-primary-400 cursor-pointer transition-colors whitespace-nowrap">最新更新</a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-100 mb-3">合作伙伴</h4>
            <div className="flex flex-col gap-2">
              <span className="text-sm text-background-500">更多合作伙伴即将入驻</span>
            </div>
          </div>
        </div>

        <div className="border-t border-background-700 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">
            &copy; 2026 7777影院. 本站所有资源均来自互联网，仅供交流学习使用。
          </p>
          <div className="flex items-center gap-4">
            <a href="#contact" className="text-xs text-background-500 hover:text-primary-400 cursor-pointer transition-colors whitespace-nowrap">联系我们</a>
            <a href="#about" className="text-xs text-background-500 hover:text-primary-400 cursor-pointer transition-colors whitespace-nowrap">关于我们</a>
            <a href="#features" className="text-xs text-background-500 hover:text-primary-400 cursor-pointer transition-colors whitespace-nowrap">平台特色</a>
          </div>
        </div>
      </div>
    </footer>
  );
}